module.exports = require('./helpers/bundle-url').getBundleURL('43O8s') + "logo.7718c6df.svg";